<script setup lang="ts">
/**
 * Left cell for the mobile service types table.
 *
 * Renders a small row index on the left and the name stack on the right:
 * - When nameUpper is present it is the primary line; nameLower sits below
 *   it in muted sans-serif (category + duration).
 * - When nameUpper is absent the row is untitled: nameLower is shown as the
 *   primary line in italic/muted style, matching the sketch.
 */
defineProps<{
  index?: number
  nameUpper?: string
  nameLower?: string
  width?: string
}>()
</script>

<template>
  <td class="st-mobile-left font-tufte text-tufte-text">
    <div class="row-layout">
      <span class="row-idx text-tufte-muted font-tufte-sans tabular-nums">{{ index }}</span>
      <div class="row-main">
        <span v-if="nameUpper" class="row-name">{{ nameUpper }}</span>
        <span v-else class="row-name row-name--untitled text-tufte-muted">{{ nameLower }}</span>
        <span v-if="nameUpper && nameLower" class="row-sub text-tufte-muted">{{ nameLower }}</span>
      </div>
    </div>
  </td>
</template>

<style scoped>
.st-mobile-left {
  vertical-align: middle;
}

.row-layout {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.row-idx {
  width: 1.5rem;
  flex-shrink: 0;
  text-align: right;
  font-size: var(--text-tufte-sm);
}

.row-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.row-name {
  font-size: var(--text-tufte-lg);
  font-weight: 500;
  line-height: 1.25;
}

.row-name--untitled {
  font-style: italic;
  font-weight: 400;
}

.row-sub {
  font-family: var(--font-tufte-sans);
  font-size: var(--text-tufte-sm);
  line-height: 1.35;
}
</style>
